import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';
import {isMobile} from 'react-device-detect';
import {CATEGORIES} from '@/enums';
import {MYFC_INITIAL_COORD} from '@/map/constants';
import {
  AreaAnalyticsFilter,
  MapActionTypes,
  MapSideMenuType,
} from '@/map/enums';
import {getZoomLevel} from '@/map/utils';

export const mapInstanceAtom = atom<naver.maps.Map | undefined>(undefined);

export const mapSideInfoAtom = atom<{
  open: boolean;
  menu?: MapSideMenuType;
}>({
  open: false,
});

export const zoomLevelAtom = atomWithStorage<number>(
  'myfc/map/zoom',
  getZoomLevel(isMobile ? 500 : 300)
);
export const mapCenterAtom = atomWithStorage<naver.maps.Coord>(
  'myfc/map/center',
  MYFC_INITIAL_COORD
);

export const currentPositionAtom = atom<{
  mapsLatLng?: naver.maps.Coord;
  geolocationPosition?: GeolocationPosition;
  active: boolean;
}>({
  active: false,
});

export const cadastralLayerAtom = atom<boolean>(false);

export const mapActionModeAtom = atom<{
  mode: MapActionTypes | null;
  options?: {
    point?: naver.maps.LatLng;
  };
} | null>(null);

export const nearbyStoreCategoryAtom = atomWithStorage<{
  active: boolean;
  selected: CATEGORIES[];
}>('nearby/store-category', {active: true, selected: []});

export const nearbyInfoAtom = atomWithStorage<{
  active: boolean;
  selected: AreaAnalyticsFilter[];
}>('nearby/info', {active: true, selected: []});
